import dynamic from "next/dynamic";

import { RegistrationStepGe } from "@/enums/registrationSteps.enum";
import {
  accountTypeSchemaGe,
  contactInfoSchemaGe,
  passwordSchemaGe,
  additionalInfoSchemaGe,
} from "@/validations/registration/registrationStepsGe.validation";

const AccountTypeComponent = dynamic(
  () => import("@/components/auth/registration/form-components/account-type"),
  { ssr: false },
);
const ContactInfo = dynamic(
  () => import("@/components/auth/registration/form-components/contact-info"),
  { ssr: false },
);
const Password = dynamic(
  () => import("@/components/auth/registration/form-components/password"),
  { ssr: false },
);
const AdditionalInfoGeorgia = dynamic(
  () =>
    import(
      "@/components/auth/registration/form-components/additional-info-georgia"
    ),
  { ssr: false },
);

export const privateStepsGe = {
  [RegistrationStepGe.ACCOUNTTYPE]: {
    stepName: "type_of_account",
    component: <AccountTypeComponent />,
    validationSchema: accountTypeSchemaGe,
  },
  [RegistrationStepGe.CONTACTINFO]: {
    stepName: "registration_contact_information",
    component: <ContactInfo />,
    validationSchema: contactInfoSchemaGe,
  },
  [RegistrationStepGe.PASSWORD]: {
    stepName: "password",
    component: <Password />,
    validationSchema: passwordSchemaGe,
  },
  [RegistrationStepGe.ADDITIONALINFO]: {
    stepName: "additional_information",
    component: <AdditionalInfoGeorgia />,
    validationSchema: additionalInfoSchemaGe,
    needsToken: true,
  },
};
